module.exports = __webpack_public_path__ + "static/media/binSimpleDark.7515318e.svg";